import React from 'react';
import { Video, Camera, Trophy, TrendingUp, Award, CheckCircle } from 'lucide-react';
import { services } from '../mock';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';

const iconMap = {
  video: Video,
  camera: Camera,
  trophy: Trophy,
  'trending-up': TrendingUp,
  award: Award
};

const ServicesSection = () => {
  return (
    <section id="services" className="bg-[#1a1a1a] py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block mb-4 px-4 py-2 bg-[#00ff41]/10 border border-[#00ff41]/30 rounded-full">
            <span className="text-[#00ff41] font-semibold text-sm tracking-wider uppercase">
              Services
            </span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-black text-white mb-4">
            How We Can Work Together
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Multiple ways to partner and drive results for your fitness brand
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => {
            const Icon = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className={`bg-gradient-to-br from-gray-900 to-black border-gray-800 hover:border-[#00ff41] transition-all duration-300 group ${
                  service.highlight ? 'ring-2 ring-[#00ff41]/50' : ''
                }`}
              >
                <CardHeader>
                  <div className="mb-4">
                    <div className="inline-flex p-3 rounded-lg bg-gradient-to-br from-[#00ff41]/20 to-[#ff6b35]/20 border border-[#00ff41]/30">
                      <Icon className="text-[#00ff41]" size={28} />
                    </div>
                    {service.highlight && (
                      <div className="mt-3">
                        <span className="inline-block px-3 py-1 bg-[#ff6b35] text-black text-xs font-bold rounded-full uppercase">
                          High Value
                        </span>
                      </div>
                    )}
                  </div>
                  <CardTitle className="text-2xl font-black text-white group-hover:text-[#00ff41] transition-colors">
                    {service.title}
                  </CardTitle>
                  <CardDescription className="text-gray-400 text-base mt-2">
                    {service.description}
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-3">
                    {service.features.map((feature, index) => (
                      <li key={index} className="flex items-start gap-2">
                        <CheckCircle className="text-[#00ff41] flex-shrink-0 mt-0.5" size={18} />
                        <span className="text-gray-300 text-sm">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <div className="mt-12 text-center">
          <div className="inline-block bg-gradient-to-r from-[#ff6b35]/10 to-[#00ff41]/10 border border-[#ff6b35]/30 rounded-lg px-6 py-4">
            <p className="text-gray-300">
              <span className="text-[#ff6b35] font-bold">Limited Availability:</span> Only taking on 3-5 new brand partnerships per month
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
